export default __webpack_public_path__ + "static/profile-88d7af1cddd53d44ee3e12955fa4ef01.png";